import { ReducerBuilder } from './reducerBuilder';
import { ItineraryState } from '../store/itineraryState';
import { ItineraryRequest } from 'acscp/api/requests';
import { Itinerary } from 'acscp/api/models/itinerary';

export const itineraryReducer =
    new ReducerBuilder<ItineraryState>({
    })
    .successfulRequestCase(ItineraryRequest, (state, itinerary: Itinerary, request) => {
        // Build store clone excluding possible old itinerary for the given booking.
        const clone = {...state};
        Object.keys(clone).forEach(itineraryId => {
            if (clone[itineraryId].bookingId === request.bookingId) {
                delete clone[itineraryId];
            }
        });

        clone[itinerary.id] = {
            ...itinerary,
            bookingId: request.bookingId,
        };

        return clone;
    })
    .build();
